export class CancelledException {
  name = 'CancelledException';
};

/**
 * Makes a series of async functions cancellable.
 * Usage:
 * 
 * let cancelController = new CancelController();
 * 
 * async function lotsOfAsyncWork() {
 *    // Only allow one invocation of "lotsOfAsyncWork" at once.
 *    cancelController.cancel();
 *    cancelController = new CancelController();
 * 
 *    await cancelController.cancellable(getA()); // instead of: await getA();
 *    await cancelController.cancellable(getB());
 *    await cancelController.cancellable(getC());
 * }
 * 
 * try {
 *   await lotsOfAsyncWork();
 * }
 * catch(e) {
 *   if (e instanceof CancelledException) {
 *     console.log('lotsOfAsyncWork() was cancelled!');
 *   }
 * }
 */
export class CancelController {
  cancelled = false;

  cancel() {
    this.cancelled = true;
  }

  async cancellable(promise) {
    this.__throwIfCancelled();
    const result = await promise;
    this.__throwIfCancelled();
    return result;
  }

  __throwIfCancelled() {
    if (this.cancelled) {
      throw new CancelledException();
    }
  }
}